import { getDebugLogger } from '~/utils/getDebugLogger';

export const uploadsLogger = getDebugLogger('uploads');
